import { NEUiInfo, NEUiInfoInitialState } from "@/types/ui";
import React, { createContext, useContext, useReducer } from "react";

const NEContext = createContext<{
  state: NEUiInfo;
  dispatch: React.Dispatch<any>;
}>({ state: NEUiInfoInitialState, dispatch: () => null });

const actionTypes = {
  SET: "SET",
  SET_STATE: "SET_STATE",
  REFRESH: "REFRESH",
  SET_UI: "SET_UI",
};

function reducer(state: NEUiInfo, action: { type: string; payload: any }): NEUiInfo {
  const { payload } = action;

  switch (action.type) {
    case actionTypes.REFRESH:
      return { ...state, refresh: state.refresh + 1 };
    case actionTypes.SET:
      return { ...state, ...action.payload };
    case actionTypes.SET_UI:
      return { ...state, ...action.payload };
    case actionTypes.SET_STATE:
      return {
        ...state,
        willExists: payload.willExists,
        collectExecutorDetails: payload.collectExecutorDetails,
        collectNokDetails: payload.collectNokDetails,
      };
    default:
      return NEUiInfoInitialState;
  }
}

const NEUiInfoProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, NEUiInfoInitialState);

  return <NEContext.Provider value={{ state, dispatch }}>{children}</NEContext.Provider>;
};

const useNEUiContext = () => {
  const ctx = useContext(NEContext);
  if (!ctx) throw new Error("useNEUiContext must be used within NEUiInfoProvider");
  return ctx;
};

export { NEContext, NEUiInfoProvider, useNEUiContext };
